module.exports = __webpack_public_path__ + "img/slika1.3071860f.png";